import { postP,get,getJ,put,deleteP,getExcel,postExcel,uploadOther,uploadOtherSort,upload,uploadnew,postPackage,getPDF  } from '@/utils/axios'
import  baseURL  from '@/utils/axios/axios'
import store from '../store'

export default {
    
    
    
    // 获取车险案件
    getCarInsurancePagedList(data){
        return get('CarInsurance/QueryCarInsurance',data)
    },

    // 获取快赔案件
    getFastPayForPagedList(data){
        return get('FastPayFor/GetCasePagedList',data)
    },

    // 获取意健险案件
    getSemanticKeyPagedList(data){
        return get('SemanticKey/GetPagedListNew',data)
    },

    
    // 车险立项
    getCarList(data){
        return get('CarInsurance/GetCarInsuranceList',data)
    },
    // 车险立项插入
    putCar(data){
        return postP('CarInsurance/PutStandCarInsurance',data)
    },
    // 车险立项更新
    updateCar(data){
        return postP('CarInsurance/UpdateStand',data)
    },
    
    updateCarF(data){
        return postP('CarInsurance/UpdateCWCar',data)
    },
    // 车险案件列表
    getCasePagedList(data){
        return get('CarInsurance/GetCasePagedList/'+data.pageIndex+'/'+data.pageSize+'/'+data.StandID)
    },
    // 车险立项导入接口
    importInsurance(file,data){
        return upload('CarInsurance/import/'+data.StandID+'?userName='+data.userName,file);
    },
    // 车险导出
    carInsuranceExport(data){
        return getExcel('CarInsurance/ExportCase',data,'车险列表')
    },
    // 车险立项批量新增
    addsSandProject(file,data){
        return upload('CarInsurance/AddsSandProject?userName='+data.userName,file)
    },
    // 车险立项批量修改
    upSandProjectC(file,data){
        return upload('CarInsurance/UpSandProject?userName='+data.userName,file)
    },
    // 取消车险案件关联
    cancelCar(data){
        return get('CarInsurance/CancelCar/'+data)
    },
    // 车险立项删除
    deleteProjectC(data){
        return get('CarInsurance/DeleteProject/'+data)
    },
    relatedCar(file,data){
        return uploadnew('CarInsurance/RelatedStand?userName='+data.userName+'&standProjectId='+data.StandProjectId,file)
    },

    // 意健险
    getKeyList(data){
        return get('SemanticKey/GetKeyList',data)
    },
    // 意健险插入
    putKey(data){
        return postP('SemanticKey/PutKey',data)
    },
    //  意健险立项更新
    updateKey(data){
        return postP('SemanticKey/UpdateJSKey',data)
    },
    updateKeyF(data){
        return postP('SemanticKey/UpdateCWKey',data)
    },
    // 意健险案件查询
    getCasePagedListSemanticKey(data){
        return get('SemanticKey/GetCasePagedList/'+data.pageIndex+'/'+data.pageSize+'/'+data.StandID)
    },
    // 意健险导出
    semanticKeyExport(data){
        return getExcel('SemanticKey/Export',data,'意健险列表')
    },
    // 意健险立项导入接口
    importSemanticKey(file,data){
        return upload('SemanticKey/import/'+data.StandID+'?userName='+data.userName,file);
    },
    // 查询所有用户
    queryAllUser(data){
        return get('Login/QueryAll',data)
    },
    // 意建险批量新增
    addsSandProjectS(file,data){
        return upload('SemanticKey/AddsSandProject?userName='+data.userName,file)

    },
    // 意建险批量修改
    upSandProjectS(file,data){
        return upload('SemanticKey/UpSandProject?userName='+data.userName,file)
    },
    // 意建险关联删除
    disassociateS(data){
        return postP('SemanticKey/Disassociate/'+data)
    },
    // 意建险案件删除
    deleteCaseS(data){
        return postP('SemanticKey/DeleteCase/'+data)
    },
    // 意建险案件关联批量取消
    cancelSemanticKey(data){
        return get('SemanticKey/CancelAssets/'+data)
    },
    // 意建立项删除
    deleteProjectS(data){
        return get('SemanticKey/DeleteProject/'+data)
    },
    
    // 快赔立项
    getFastPayForList(data){
        return get('FastPayFor/GetAssetsList',data)
    },
    // 快赔立项插入
    putPay(data){
        return postP('FastPayFor/PutStandAssets',data)
    },
    // 快赔立项更新
    updatePay(data){
        return postP('FastPayFor/UpdateJSAssets',data)
    },
    updatePayF(data){
        return postP('FastPayFor/UpdateCWPay',data)
    },
    // 快赔案件列表
    // getCasePagedListFastPayFor(data){
    //     return get('FastPayFor/GetCasePagedList/'+data.pageIndex+'/'+data.pageSize+'/'+data.StandID)
    // },
    getPagedListFastPayFor(data){
        return get('FastPayFor/GetPagedListNew/',data)
    },
    // 快赔立项导入接口
    importFastPayFor(file,data){
        return upload('FastPayFor/import/'+data.StandID+'?userName='+data.userName,file);
    },
    // 快赔导出案件
    fastPayForExport(data){
        return getExcel('FastPayFor/Export/',data,'快赔列表')
    },
    // 快赔立项批量新增
    addsSandProjectF(file,data){
        return upload('FastPayFor/AddsSandProject?userName='+data.userName,file)

    },
    // 快赔立项批量修改
    upSandProjectF(file,data){
        return upload('FastPayFor/UpSandProject?userName='+data.userName,file)
    },
    // 快赔立项删除
    deleteProjectFastPayFor(data){
        return get('FastPayFor/DeleteProject/'+data)
    },
    // 快赔案件删除
    deleteCaseF(data){
        return postP('FastPayFor/DeleteCase/'+data)
    },
    // 快赔案件关联批量取消
    cancelFastPayFor(data){
        return postP('FastPayFor/CancelAssets/',data)
    },
    // 快赔立项删除
    deleteProjectF(data){
        return get('FastPayFor/DeleteProject/'+data)
    },
    // 快赔立项关联
    relatedFastPayFor(file,data){
        return uploadnew('FastPayFor/import?userName='+data.userName+'&standProjectId='+data.StandProjectId,file)
    },


    // 获取资产评估案件
    queryAssetss(data){
        return get('Assets/QueryAssetss',data)
    },
    // 资产评估立项
    getAssetsList(data){
        return get('Assets/GetAssetsList',data)
    },
    // 资产评估立项插入
    putAssets(data){
        return postP('Assets/PutStandAssets',data)
    },
    // 资产评估立项更新
    updateAssets(data){
        return postP('Assets/UpdateStand',data)
    },
    // 资产评估立项关联
    relatedStandAssets(file,data){
        return uploadnew('Assets/RelatedStand?userName='+data.userName+'&standProjectId='+data.StandProjectId,file)
    },

    // 资产评估立项取消关联
    cancelAssets(data){
        return postP('Assets/cancelAssets',data)
    },
    
    // 资产评估立项导入接口
    importAssets(file,data){
        return upload('Assets/import/'+data.StandID+'?userName='+data.userName,file);
    },
    // 资产评估导出案件
    assetsExport(data){
        return getExcel('Assets/ExportCase',data,'资产列表')
    },
    // 资产批量新增
    addsSandProjectA(file,data){
        return upload('Assets/AddsSandProject?userName='+data.userName,file)

    },
    // 资产立项批量修改
    upSandProjectA(file,data){
        return upload('Assets/UpSandProject?userName='+data.userName,file)
    },
    // 资产评估关联删除
    disassociateA(data){
        return postP('Assets/Disassociate/'+data)
    },
    // 资产评估案件删除
    deleteAssets(data){
        return get('Assets/DeleteAssets/',data)
    },
   
    // 资产立项删除
    deleteProjectA(data){
        return get('Assets/DeleteProject/'+data)
    },

    
    // 理赔案件列表
    queryClaims(data){
        return get('Claims/QueryClaimss',data)
    },
    // 导出案件
    exportClaims(data){
        return getExcel('Claims/ExportStand',data,'理赔列表')
    },
    // 导出立项
    claimsStandExport(data){
        return getExcel('Claims/ExportCase',data,'理赔列表')
    },
    // 获取理赔立项列表
    getClaimsList(data){
        return get('Claims/GetClaimsList',data)
    },
    // 插入理赔
    putClaims(data){
        return postP('Claims/PutStandClaims',data)
    },
    // 更新理赔
    upClaims(data){
        return postP('Claims/UpClaims',data)
    },
    // 取消理赔案件关联
    cancelClaims(data){
        return postP('Claims/CancelClaims',data)
    },
    // 理赔立项关联
    relatedStandClaims(file,data){
        return uploadnew('Claims/RelatedStand?userName='+data.userName+'&standProjectId='+data.StandProjectId,file)
    },
    // 删除理赔案件
    deleteClaims(data){
        return get('Claims/DeleteClaims/'+data)
    },

    
    // 理赔立项插入
    putStandClaims(data){
        return postP('Claims/PutStandClaims',data)
    },
    // 更新理赔立项
    updateStandClaims(data){
        return postP('Claims/UpdateStand',data)
    },
    // 理赔删除立项——新
    deleteProjectClaims(data){
        return get('Claims/DeleteProject/'+data)
    },

    updateStandClaimsF(data){
        return postP('Claims/UpdateCWAssets',data)
    },
    
   
    
    // 批量修改
    uPFinanceClaims(file,data){
        return upload('Claims/UPFinance?userName='+data.userName,file)
    },
    
    
    addsSandProjectClaims(file,data){
        return upload('Claims/AddsSandProject?userName='+data.userName,file)
    },
    
    // 查询角色
    getRole(data){
        return get('Role/Get')
    },
    // 新增角色
    addRole(data){
        return postP('Role/AddRole',data)
    },
    // 删除角色
    deleteRole(data){
        return postP('Role/DeleteRole',data)
    },
    // 修改角色
    updateRole(data){
        return postP('Role/UpRole',data)
    },




    // 更新用户信息
    updateUser(data){
        return postP('Login/UpdateUser',data)
    },
    // 注册用户信息
    registerUser(data){
        return postP('Login/Register',data)
    },

    // 数据库读取统计数据
    getCPAllData(data){
        return get('Statistics/GetCPAllData',data)
    },
    // 查询清分统计表
    QueryerSorting(data){
        return get('Statistics/QueyerSorting',data)
    },
    // 导出最新一次数据
    exportLatest(data){
        return getExcel('Statistics/ExportLatest',data,'数据')
    },
    // 读取缓存
    getResSummary(data){
        return get('Statistics/GetResSummary',data)
    },
    invoiceImg(file,params){
        return upload('External/InvoiceImg',file,params)
    },
    // 获取清分对象列表
    queryBusinessClearing(data){
        return get('Clearing​/QueryBusiness​',datas)
    },

    // 清分公司列表
    externalQueryByStandID(data){
        return get('External/QueryPS',data)
    },
    // 清分公司添加
    addClearing(data){
        return postP('External/InserPs',data)
    },
     // 清分公司添加
     updateClearing(data){
        return postP('External/UpdatePs',data)
    },
    // // 添加清分公司数据
    // clearingInsertBusiness(data){
    //     return postP('Clearing/InsertBusiness',data)
    // },
    // // 编辑清分公司数据
    // clearingUpdateBusiness(data){
    //     return put('Clearing/UpdateBusiness',data)
    // },

    // 资产批量修改财务立项
    upCWSandProjectA(file,params){
        return upload('Assets/UpCWSandProject?userName='+params.userName,file)
    },
    // 车险批量修改财务立项
    upCWSandProjectC(file,params){
        return upload('CarInsurance/UpCWSandProject?userName='+params.userName,file)
    },
    // 快赔批量修改财务立项
    upCWSandProjectF(file,params){
        return upload('FastPayFor/UpCWSandProject?userName='+params.userName,file)
    },
    // 意健险批量修改财务立项
    upCWSandProjectS(file,params){
        return upload('SemanticKey/UpdateCWSandProject?userName='+params.userName,file)
    },
    // 发票查询
    queryInvoice(data){
        return get('External/QueryInvoice',data)
    },
    // 发票添加
    insertInvoice(data,standType){
        return postP('External/InsertInvoice?standType='+standType,data)
    },
    // 发票更新
    updateInvoice(data,standID,standType){
        return postP('External/UpdateInvoice?standID='+standID+'&standType='+standType,data)
    },

    // 车险立项导出
    standExportC(data){
        return getExcel('CarInsurance/StandExport',data,'车险立项')
    },
    // 资产立项导出
    standExportA(data){
        return getExcel('Assets/StandExport',data,'资产立项')
    },
    // 理赔立项导出
    standExportCl(data){
        // return getExcel('Claims/StandExport',data,'理赔立项')
        return getExcel('Claims/ExportStand',data,'理赔立项')
    },
    // 快赔立项导出
    standExportF(data){
        return getExcel('FastPayFor/StandExport',data,'快赔立项')
    },
    // 意健险立项导出
    standExportS(data){
        return getExcel('SemanticKey/StandExport',data,'意健险立项')
    },

    // 公司列表
    queryAllCompany(data){
        return get('External/QueryAllCompany',data)
    },
    // 新增分公司
    inserCompany(data){
        return postP('External/InserCompany',data)
    },
    // 修改分公司
    updateCompany(data){
        return postP('External/UpdateCompany',data)
    },
    // 删除分公司
    deleteCompany(data){
        return postP('External/DeleteCompany',data)
    },


    // 部门列表
    queryDepartment(data){
        return get('External/QueryDepartment',data)
    },
    // 新增部门
    inserDepartment(data){
        return postP('External/InserDepartment',data)
    },
    // 修改部门
    updateDepartment(data){
        return postP('External/UpdateDepartment',data)
    },
    // 删除部门
    deleteDepartment(data){
        return postP('External/DeleteDepartment',data)
    },

    // 更改密码
    updateUserPwd(data){
        return get('Login/UpdateUserPwd',data)
    },

    // 取消单个案件关联-车险-carInsuranceNo
    cancelCarInsurance(data){
        return postP('CarInsurance/CancelCarInsurance/',data)
    },
    // 取消单个案件关联-资产-CaseID
    cancelCaseA(data){
        return get('Assets/Disassociate/'+data)
    },
    // 取消单个案件关联-意健险-CaseID
    cancelCaseS(data){
        return get('SemanticKey/Disassociate/'+data)
    },
    // 取消单个案件关联-理赔-caseNo
    cancelCaseSC(data){
        return get('Claims/CancelSingleClaims/'+data)
    },
    // 取消单个案件关联-快赔-reportNo
    cancelCaseF(data){
        return get('FastPayFor/Disassociate/'+data)
    },
    

    // 车险立项删除
    deleteProjectCar(data){
        return get('CarInsurance/DeleteProject/'+data)
    },
    // 资产评估控制器
    deleteProjectAssets(data){
        return get('Assets/DeleteProject/'+data)
    },
    
    // 快赔控制器
    deleteProjectFast(data){
        return get('FastPayFor/DeleteProject/'+data)
    },
    // 意健险控制器
    deleteProjectSemanticKey(data){
        return get('SemanticKey/DeleteProject/'+data)
    },



    // 案件查询——案件
    carOutsourceGetPagedList(data){
        return get('CarOutsource/QueryCarOutsources',data)
    },
    // 案件导出——案件
    carOutsourceExport(data){
        return getExcel('CarOutsource/ExportCase',data,'车险列表(外包)')
    },
    // 插入车险外包案件——案件
    carOutsourcePutCarOutsource(data){
        return postP('CarOutsource/PutCarOutsource',data)
    },
    // 更新车险外包案件——案件
    carOutsourceUpCarOutsource(data){
        return postP('CarOutsource/UpCarOutsource',data)
    },
    // 立项查询——立项
    carOutsourceGetStandList(data){
        return get('CarOutsource/GetCarOutsourceList',data)
    },
    // 插入查询——立项
    putStandCarOutsource(data){
        return postP('CarOutsource/PutStandCarOutsource',data)
    },
    // 更新查询——立项
    carOutsourceUpdataStand(data){
        return postP('CarOutsource/UpdateStand',data)
    },
    
    // 删除立项——立项
    deleteProjectCarOutsource(data){
        return get('CarOutsource/DeleteProject/'+data)
    },
    // 取消关联立项——立项
    cancelCarOutsource(data){
        return postP('CarOutsource/CancelCarOutsource',data)
    },

    // 立项导入——立项
    carOutsourceAddsSandProject(file,data){
        return upload('CarOutsource/AddsSandProject?userName='+data.userName,file)
    },
    // 车险外包立项关联
    carOutsourceRelatedStand(file,data){
        return uploadnew('CarOutsource/RelatedStand?userName='+data.userName+'&standProjectId='+data.StandProjectId,file)
    },


    // 导出立项
    carOutsourceStandExport(data){
        // /api/CarOutsource/ExportStand
        return getExcel('CarOutsource/ExportStand',data,'车险立项列表(外包)')
    },
    // 批量修改立项
    carOutsourceUpSandProject(file,data){
        return upload('CarOutsource/UpSandProject?userName='+data.userName,file)
    },
    // 财务批量修改立项
    carOutsourceUpCWSandProject(file,data){
        return upload('CarOutsource/UpCWSandProject?userName='+data.userName,file)
    },

    insertMechanisms(data){
        return postP('Mechanism/InsertMechanisms',data)
    },
    updataMechanisms(data){
        return postP('Mechanism/UpdataMechanisms',data)
    },
    queryMechanisms(data){
        return get('Mechanism/QueryMechanisms',data)
    },
    qeryMechanismsBYName(data){
        return get('Mechanism/QueryMechanismsBYName',data)
    },
    delMechanisms(data){
        return postP('Mechanism/DelMechanisms',data)
    },

    uploadOther(file,params){
        return uploadOther('',file,params)
    },




    // 意健险——查询案件列表——新
    queryAccidentRisk(data){
        return get('AccidentRisk/QueryAccidentRisk',data)
    },
    // 意健险——案件删除——新
    deleteAccidentRisk(data){
        return get('AccidentRisk/DeleteAnXinDcTaskId',data)
    },
    // 意健险——插入意健险案件——新
    insterAccidentRisk(data){
        return postP('AccidentRisk/InsterAccidentRisk',data)
    },
    // 意健险——更新意健险案件——新
    updateAccidentRisk(data){
        return postP('AccidentRisk/UpdateAccidentRisk',data)
    },
    // 意健险——导出意健险案件——新
    accidentRiskExport(data){
        return getExcel('AccidentRisk/AccidentRiskExport',data,'意健险案件列表')
    },
    

    // 意健险——查询立项列表——新
    querySPAccidentRiskother(data){
        return get('AccidentRisk/QuerySPAccidentRiskother',data)
    },

    // 意健险——查询立项列表——新
    querySPAccidentRisk(data){
        return get('AccidentRisk/QuerySPAccidentRisk',data)
    },
    // 意健险——插入意健险立项——新
    insterSPAccidentRisk(data){
        return postP('AccidentRisk/InsterSPAccidentRisk',data)
    },
    // 意健险——批量新增意健险立项——新
    importProjectAccidentRisk(file,data){
        return uploadnew('AccidentRisk/ImportProject?userName='+data.userName,file)
    },
    // 意健险——更新意健险立项——新
    updateSPAccidentRisk(data){
        return postP('AccidentRisk/UpdateSPAccidentRisk',data)
    },

    // 意健险——删除意健险立项——新
    deleteSPAccidentRisk(data){
        return get('AccidentRisk/DeleteSPAccidentRisk',data)
    },

    // 意健险——意健险立项关联案件——新
    relatedCaseAccidentRisk(file,data){
        return uploadnew('AccidentRisk/RelatedCase?userName='+data.userName+'&standProjectId='+data.StandProjectId,file)
    },
    // 意健险——意健险立项关联案件——新
    upImportProjectAccidentRisk(file,data){
        return uploadnew('AccidentRisk/UpImportProject?userName='+data.userName,file)
    },
    // 意健险——意健险立项取消关联案件——新
    cancelRelatedCaseAccidentRisk(data){
        return postP('AccidentRisk/CancelRelatedCase',data)
    },

    // 日志操作接口
    queryProjectLog(data){
        return get('ProjectLog/queryProjectLog',data)
    },

    // 日志操作接口
    opLogs(data){
        return get('OpLogs',data)
    },

    // 客户查询
    queryCustomer(data){
        return get('Customer/QueryCustormer',data)
    },
    // 添加客户
    addCustomer(data){
        return postP('Customer/AddCustormer',data)
    },
    // 删除客户
    delCustomer(data){
        return postP('Customer/DelCustormer',data)
    },


    // 意建立项关联单个案件
    singleAssociationSemanticKey(data){
        return postP('SemanticKey/SingleAssociation',data)
    },

    // 车险立项关联单个案件
    singleAssociationCarInsurance(data){
        return postP('CarInsurance/SingleAssociation',data)
    },
    // 车险外包立项关联单个案件
    singleAssociationCarOutsurance(data){
        return postP('CarOutsource/SingleAssociation',data)
    },
    // 意健险立项关联单个案件
    singleAssociationAccidentRisk(data){
        return postP('AccidentRisk/SingleAssociation',data)
    },
    // 理赔立项关联单个案件
    singleAssociationClaims(data){
        return postP('Claims/SingleAssociation',data)
    },
    // 资产评估立项关联单个案件
    singleAssociationAssets(data){
        return postP('Assets/SingleAssociation',data)
    },
    // 快赔立项关联单个案件
    singleAssociationFastPayFor(data){
        return postP('FastPayFor/SingleAssociation',data)
    },
    

    statisticsTreasurer(data){
        return get('Statistics/Treasurer',data)
    },
    statisticsUpTreasurer(data){
        return postP('Statistics/UpTreasurer',data)
    },

    statisticsBatchUpTreasurer(file){
        return upload('Statistics/BatchUpTreasurer',file)
        // return upload('CarInsurance/import/'+data.StandID+'?userName='+data.userName,file);
    },

    // 意健险——导出意健险立项——新
    SPAccidentRiskExport(data){
        return getExcel('AccidentRisk/SPAccidentRiskExport',data,'意健险立项列表')
    },
    

    // 删除
    deleteCarInsurance(data){
        return get('CarInsurance/DeleteCarInsurance',data)
    },
    deleteCarOutsource(data){
        return get('CarOutsource/DeleteCarOutsource',data)
    },



    // 查询日志
    externalQueryCaseLogs(datas){
        return postP('External/QueryCaseLogs',datas)
    },

    
    // 转移立项
    diverStand(data){
        return postP('Statistics/DivertStand',data)
    },
    // 数据表
    dataSheet(data){
        return postP('Statistics/DataSheet',data)
    },
    plateSheet(data){
        return postP('Statistics/PlateSheet',data)
    },
    // 数据表
    handleDate(data){
        return postP('Statistics/HandleDate',data)
    },
    // 公司数据
    statisticsCompanyData(data){
        return postP('Statistics/CompanyData',data)
    },
    // 公司数据
    statisticsGetCompany(data){
        return get('Statistics/GetCompany',data)
    },
    // 导出立项
    statisticsExportStand(data){
        return postExcel('Statistics/ExportStand',data,'立项列表')
    },
    // 金蝶复推
    pushKinDie(data){
        return postP('Statistics/AddsSandProject',data)
    },
    againInvoiceImg(data){
        return get('External/againInvoiceImg',data)
    },
    queryNotPushKeeKingdeeNum(data){
        return get('External/QueryNotPushKeeKingdeeNum',data)
    },
    divertStandProject(data){
        return postP('Statistics/DivertStandProject',data)
    },
    // uploadOtherSort(file,params){
    //     return uploadOtherSort('',file,params)
    // },
    // upload(file,params){
    //     return upload('Common/UploadFile',file,params)
    // },



    
    // 案件查询——案件
    QueryAssetsOutsources(data){
        return get('AssetsOutsource/QueryAssetsOutsources',data)
    },
    // 案件导出——案件
    AssetsOutsourceExport(data){
        return getExcel('AssetsOutsource/ExportCase',data,'财产险列表(外包)')
    },
    // 案件删除——案件
    DeleteAssetesOutsource(data){
        return get('AssetsOutsource/DeleteAssetesOutsource/',data)
    },
    // 插入车险外包案件——案件
   AssetsOutsourcePutCarOutsource(data){
        return postP('AssetsOutsource/PutCarOutsource',data)
    },
    // 更新车险外包案件——案件
   AssetsOutsourceUpCarOutsource(data){
        return postP('AssetsOutsource/UpCarOutsource',data)
    },
    // 立项查询——立项
   AssetsOutsourceGetPagedList(data){
        return get('AssetsOutsource/GetAssetsOutsourceList',data)
    },
    // 插入查询——立项
    putStandAssetsOutsource(data){
        return postP('AssetsOutsource/PutStandCarOutsource',data)
    },
    // 更新查询——立项
   AssetsOutsourceUpdataStand(data){
        return postP('AssetsOutsource/UpdateStand',data)
    },
    
    // 删除立项——立项
    deleteProjectAssetsOutsource(data){
        return get('AssetsOutsource/DeleteProject/'+data)
    },
    // 取消关联立项——立项
    cancelAssetsOutsource(data){
        return postP('AssetsOutsource/CancelAssetsOutsource',data)
    },

    // 立项导入——立项
    AssetsOutsourceAddsSandProject(file,data){
        return upload('AssetsOutsource/AddsSandProject?userName='+data.userName,file)
    },
    // 车险外包立项关联
    AssetsOutsourceRelatedStand(file,data){
        return uploadnew('AssetsOutsource/RelatedStand?userName='+data.userName+'&standProjectId='+data.StandProjectId,file)
    },


    // 导出立项
   AssetsOutsourceStandExport(data){
        // /api/CarOutsource/ExportStand
        return getExcel('AssetsOutsource/ExportStand',data,'财产险立项列表(外包)')
    },
    // 批量修改立项
   AssetsOutsourceUpSandProject(file,data){
        return upload('AssetsOutsource/UpSandProject?userName='+data.userName,file)
    },
    // 财务批量修改立项
   AssetsOutsourceUpCWSandProject(file,data){
        return upload('AssetsOutsource/UpCWSandProject?userName='+data.userName,file)
    },
     // 立项关联
     singleAssociationAssetsOutsource(data){
        return postP('AssetsOutsource/SingleAssociation',data)
    },
    
}